// Language translations for the entire portal
const translations = {
  en: {
    // Navigation
    nav: {
      graphicWorks: "Graphic Works",
      rumboGroup: "Rumbo Group",
      investorPortal: "Investor Portal",
      resources: "Resources",
      admin: "Admin",
      contact: "Contact",
      book: "Book"
    },
    // Landing Page
    landing: {
      est: "Est. 1993",
      aiPowered: "AI-Powered",
      gwTitle: "GRAPHIC",
      gwTitleAccent: "WORKS",
      gwDesc: "33 years of premium visual solutions for Puerto Rico's most prestigious brands",
      gwTags: ["POP Displays", "Vehicle Wraps", "Signage"],
      gwCta: "Explore Legacy",
      rumboTitle: "RUMBO",
      rumboTitleAccent: "GROUP",
      rumboDesc: "Puerto Rico's first AI-native marketing agency. Setting the course for digital growth.",
      rumboTags: ["AI Marketing", "Web Creation", "Automation"],
      rumboCta: "Discover Future",
      investorCta: "Investor & Partner Portal"
    },
    // Graphic Works Page
    gw: {
      heroTag: "Since 1993",
      heroTitle: "33 Years of",
      heroTitleAccent: "Visual Excellence",
      heroDesc: "Puerto Rico's premier provider of POP displays, vehicle wraps, signage, and digital printing for the world's most prestigious brands.",
      getQuote: "Get a Quote",
      viewPortfolio: "View Portfolio",
      bookConsultation: "Book Consultation",
      stats: {
        years: "Years in Business",
        projects: "Projects Completed",
        brands: "Brands Served",
        installation: "Installation in PR"
      },
      servicesTag: "Our Services",
      servicesTitle: "Solutions That Drive Sales",
      services: {
        pop: { title: "POP Displays", desc: "High-impact point-of-purchase displays that boost sales up to 30%" },
        branding: { title: "Store Branding", desc: "Transform retail spaces into immersive brand experiences" },
        channel: { title: "Channel Letters", desc: "Illuminated signage that attracts customers 24/7" },
        large: { title: "Large Format", desc: "Window graphics and murals that stop traffic" },
        vehicle: { title: "Vehicle Wraps", desc: "Mobile advertising generating 70,000+ daily impressions" },
        design: { title: "Retail Design", desc: "Strategic creativity that communicates and converts" }
      },
      clientsTag: "Trusted by Leading Brands",
      portfolioTag: "Our Work",
      portfolioTitle: "Project Portfolio",
      portfolioDesc: "Over 2,500 projects completed for the most prestigious brands",
      portfolioCategories: {
        all: "All",
        pop: "POP Displays",
        vehicle: "Vehicle Wraps",
        signage: "Signage",
        largeformat: "Large Format",
        branding: "Branding"
      },
      quoteTag: "Get Started",
      quoteTitle: "Request a Quote",
      quoteDesc: "Tell us about your project and we'll get back to you within 24 hours.",
      visitUs: "Visit Us",
      hours: "Mon-Fri: 9AM - 5PM",
      form: {
        name: "Full Name *",
        email: "Email *",
        phone: "Phone",
        company: "Company",
        service: "Select Service",
        serviceOptions: {
          pop: "POP Displays",
          vehicle: "Vehicle Wraps",
          signage: "Signage",
          branding: "Store Branding",
          largeformat: "Large Format Printing",
          other: "Other"
        },
        message: "Tell us about your project *",
        submit: "Submit Request",
        sending: "Sending...",
        sent: "Sent!",
        success: "Thank you! We'll be in touch soon.",
        error: "Something went wrong. Please try again."
      }
    },
    // Testimonials
    testimonials: {
      tag: "Client Success Stories",
      title: "What Our Clients Say",
      subtitle: "33 years of delivering excellence to Puerto Rico's most prestigious brands"
    },
    // Rumbo Group Page
    rumbo: {
      heroTag: "Puerto Rico's First AI-Native Agency",
      heroTitle: "AI Marketing for",
      heroTitleAccent: "Business Growth",
      heroDesc: "Enterprise-level AI marketing for small and mid-size businesses in Puerto Rico and beyond. Powered by AI. Delivered by experts.",
      viewPricing: "View Pricing",
      investorInfo: "Investor Info",
      bookConsultation: "Book Consultation",
      valueProps: {
        ai: "AI-Powered",
        bilingual: "Bilingual EN/ES",
        tax: "4% Tax (Act 60)",
        market: "PR + LATAM"
      },
      servicesTag: "Our Services",
      servicesTitle: "8 AI-Powered Services",
      servicesDesc: "All services leverage AI for speed and quality, delivering enterprise-level results at SMB prices.",
      services: {
        web: { title: "Web Creation", desc: "AI-powered website design and development" },
        social: { title: "Social Media Management", desc: "Full-service social management using Digital Works AI" },
        app: { title: "Custom App Creation", desc: "Business apps, client portals, internal tools" },
        ads: { title: "Paid Ad Management", desc: "Meta Ads, Google Ads, TikTok Ads" },
        automation: { title: "AI Automation", desc: "Chatbots, customer service, lead nurturing" },
        brand: { title: "Brand Identity", desc: "Logo design, brand guidelines, visual systems" },
        email: { title: "Email Marketing", desc: "AI-powered campaigns and sequences" },
        content: { title: "Content Strategy", desc: "Full content calendars, copywriting, video scripts" }
      },
      pricingTag: "Pricing",
      pricingTitle: "Monthly Retainer Tiers",
      pricingDesc: "Predictable pricing. Powerful results. Scale as you grow.",
      pricing: {
        basico: {
          name: "Básico",
          price: "$800-$1,500",
          period: "/month",
          desc: "For small businesses ready to establish a professional digital presence",
          features: ["1-2 core services", "Social media management", "Basic reporting", "Email support", "Monthly strategy call"]
        },
        profesional: {
          name: "Profesional",
          price: "$2,500-$4,500",
          period: "/month",
          desc: "Full digital marketing suite for growing businesses",
          features: ["3-5 bundled services", "Content creation", "Paid ad management", "AI automation basics", "Bi-weekly calls", "Priority support"],
          popular: "MOST POPULAR"
        },
        empresarial: {
          name: "Empresarial",
          price: "$7,500-$15,000+",
          period: "/month",
          desc: "Full AI agency partnership for established companies",
          features: ["All services included", "Dedicated account manager", "Custom AI solutions", "Daily monitoring", "24/7 priority support", "Quarterly strategy reviews"]
        }
      },
      getStarted: "Get Started",
      synergyTag: "The Ecosystem",
      synergyTitle: "Graphic Works + Rumbo Group",
      synergyDesc: "One trusted relationship. Complete business solutions. From physical signage and retail displays to AI-powered digital marketing — we've got your brand covered from every angle.",
      synergyGw: { title: "Graphic Works", desc: "Physical presence. 33 years of expertise in POP displays, signage, and vehicle wraps for luxury retail brands." },
      synergyRumbo: { title: "Rumbo Group", desc: "Digital presence. AI-powered marketing, web development, and automation for the modern business landscape." },
      contactTag: "Let's Talk",
      contactTitle: "Start Your AI Journey",
      contactDesc: "Ready to transform your digital presence? Tell us about your business.",
      form: {
        interest: "What interests you?",
        interestOptions: {
          basico: "Básico Tier ($800-$1,500/mo)",
          profesional: "Profesional Tier ($2,500-$4,500/mo)",
          empresarial: "Empresarial Tier ($7,500+/mo)",
          project: "One-time Project",
          partnership: "Partnership Opportunity"
        },
        message: "Tell us about your business and goals *",
        submit: "Let's Connect"
      }
    },
    // Resource Center
    resources: {
      heroTag: "Marketing Resource Center",
      heroTitle: "Everything You Need to",
      heroTitleAccent: "Present & Sell",
      heroDesc: "Complete marketing toolkit for presentations, pitches, emails, and advertising campaigns.",
      categories: {
        all: "All Resources",
        business: "Business Documents",
        onepagers: "One-Pagers",
        presentations: "Presentations",
        branding: "Branding Assets",
        email: "Email Templates",
        social: "Social Media"
      },
      sections: {
        business: {
          title: "Business Documents",
          desc: "Official business plans, financial projections, and investor materials"
        },
        onepagers: {
          title: "One-Page Teasers",
          desc: "Quick overview documents perfect for email attachments and introductions"
        },
        presentations: {
          title: "Presentations",
          desc: "Investor decks and sales presentations ready to customize"
        },
        branding: {
          title: "Branding Assets",
          desc: "Logos, brand guidelines, and visual identity elements"
        },
        email: {
          title: "Email Templates",
          desc: "Ready-to-send email templates for outreach and follow-ups"
        },
        social: {
          title: "Social Media Kit",
          desc: "Graphics and content for social media marketing"
        }
      },
      download: "Download",
      preview: "Preview",
      copyEmail: "Copy to Clipboard",
      copied: "Copied!",
      useTemplate: "Use Template"
    },
    // Investor Portal
    investor: {
      heroTag: "Investor & Partner Portal",
      heroTitle: "Building Puerto Rico's",
      heroTitleAccent: "AI Marketing Future",
      heroDesc: "First-mover advantage in an untapped market. 4% tax structure. $3M+ revenue trajectory.",
      metrics: {
        revenue: { value: "$3M+", label: "Year 3 Revenue Target" },
        tax: { value: "4%", label: "Corporate Tax (Act 60)" },
        clients: { value: "100+", label: "Target Client Base" },
        experience: { value: "33 Years", label: "Industry Experience" }
      },
      projections: {
        title: "Revenue Projections",
        subtitle: "Year 1 Monthly Growth Trajectory",
        revenue: "Revenue",
        netAfterTax: "Net After Tax"
      },
      act60: {
        title: "Act 60 Tax Advantage",
        desc: "Puerto Rico's Act 60 provides a significant financial advantage for export services businesses. Rumbo Group qualifies for these benefits, enabling greater reinvestment and faster growth.",
        corpTax: "Corporate Tax Rate",
        divTax: "PR Dividend Tax",
        duration: "Decree Duration"
      },
      advantages: {
        title: "Competitive Moat",
        subtitle: "Advantages that compound and aren't easily replicated",
        items: [
          { title: "First AI-Native Agency in PR", desc: "First-mover position to define the category and set pricing" },
          { title: "Proprietary Digital Works AI", desc: "Built, owned platform providing structural cost advantages" },
          { title: "33-Year Client Relationships", desc: "Immediate access to established PR businesses via Graphic Works" },
          { title: "Bilingual EN/ES Operations", desc: "Authentic service for PR, US Hispanic, and LATAM markets" },
          { title: "Act 60 Tax Structure", desc: "4% corporate tax vs 21-37% standard US rates" },
          { title: "Ultra-Low Overhead", desc: "AI-augmented operations with $1,800/month overhead" }
        ]
      },
      downloads: {
        title: "Download Center",
        subtitle: "Access our comprehensive business documentation"
      },
      cta: {
        title: "Interested in Partnering?",
        desc: "Whether you're an investor, potential partner, or simply want to learn more, we'd love to connect and explore opportunities.",
        contactUs: "Contact Us",
        call: "(787) 564-4035"
      }
    },
    // Admin Dashboard
    admin: {
      title: "Admin Dashboard",
      login: {
        title: "Admin Login",
        password: "Password",
        submit: "Login",
        error: "Invalid password"
      },
      stats: {
        total: "Total Inquiries",
        new: "New",
        contacted: "Contacted",
        converted: "Converted",
        downloads: "Downloads"
      },
      filters: {
        all: "All",
        graphicWorks: "Graphic Works",
        rumboGroup: "Rumbo Group",
        statusAll: "All Status",
        new: "New",
        contacted: "Contacted",
        converted: "Converted",
        archived: "Archived"
      },
      table: {
        date: "Date",
        name: "Name",
        email: "Email",
        company: "Company",
        type: "Type",
        status: "Status",
        actions: "Actions"
      },
      detail: {
        phone: "Phone",
        service: "Service/Interest",
        message: "Message",
        notes: "Notes",
        notesPlaceholder: "Add notes about this contact...",
        updateStatus: "Update Status",
        saveNotes: "Save Notes",
        delete: "Delete",
        close: "Close"
      },
      noContacts: "No contacts found"
    },
    // Booking Modal
    booking: {
      title: "Book a Consultation",
      desc: "Schedule a meeting with our team or contact us directly:",
      schedule: "Schedule on Calendly",
      respondTime: "We respond within 24 hours"
    },
    // Footer
    footer: {
      rumboDesc: "Puerto Rico's first AI-native marketing agency. Setting the course for digital growth.",
      services: "Services",
      portfolio: "Portfolio",
      getQuote: "Get Quote",
      aiServices: "AI Services",
      pricing: "Pricing",
      contact: "Contact",
      rights: "All rights reserved."
    },
    // Common
    common: {
      phone: "Phone",
      email: "Email",
      location: "Location",
      chatWithUs: "Chat with us!"
    }
  },
  es: {
    // Navigation
    nav: {
      graphicWorks: "Graphic Works",
      rumboGroup: "Rumbo Group",
      investorPortal: "Portal de Inversores",
      resources: "Recursos",
      admin: "Admin",
      contact: "Contacto",
      book: "Agendar"
    },
    // Landing Page
    landing: {
      est: "Est. 1993",
      aiPowered: "Impulsado por IA",
      gwTitle: "GRAPHIC",
      gwTitleAccent: "WORKS",
      gwDesc: "33 años de soluciones visuales premium para las marcas más prestigiosas de Puerto Rico",
      gwTags: ["Exhibidores POP", "Rotulación Vehicular", "Señalización"],
      gwCta: "Explorar Legado",
      rumboTitle: "RUMBO",
      rumboTitleAccent: "GROUP",
      rumboDesc: "La primera agencia de marketing nativa de IA en Puerto Rico. Marcando el rumbo del crecimiento digital.",
      rumboTags: ["Marketing IA", "Creación Web", "Automatización"],
      rumboCta: "Descubrir el Futuro",
      investorCta: "Portal de Inversores y Socios"
    },
    // Graphic Works Page
    gw: {
      heroTag: "Desde 1993",
      heroTitle: "33 Años de",
      heroTitleAccent: "Excelencia Visual",
      heroDesc: "El proveedor líder de Puerto Rico en exhibidores POP, rotulación vehicular, señalización e impresión digital para las marcas más prestigiosas del mundo.",
      getQuote: "Solicitar Cotización",
      viewPortfolio: "Ver Portafolio",
      bookConsultation: "Agendar Consulta",
      stats: {
        years: "Años en el Negocio",
        projects: "Proyectos Completados",
        brands: "Marcas Atendidas",
        installation: "Instalación en PR"
      },
      servicesTag: "Nuestros Servicios",
      servicesTitle: "Soluciones que Impulsan Ventas",
      services: {
        pop: { title: "Exhibidores POP", desc: "Exhibidores de alto impacto que aumentan ventas hasta 30%" },
        branding: { title: "Branding de Tienda", desc: "Transforma espacios retail en experiencias de marca inmersivas" },
        channel: { title: "Letras de Canal", desc: "Señalización iluminada que atrae clientes 24/7" },
        large: { title: "Gran Formato", desc: "Gráficos de vitrina y murales que detienen el tráfico" },
        vehicle: { title: "Rotulación Vehicular", desc: "Publicidad móvil generando 70,000+ impresiones diarias" },
        design: { title: "Diseño Retail", desc: "Creatividad estratégica que comunica y convierte" }
      },
      clientsTag: "Marcas que Confían en Nosotros",
      portfolioTag: "Nuestro Trabajo",
      portfolioTitle: "Portafolio de Proyectos",
      portfolioDesc: "Más de 2,500 proyectos completados para las marcas más prestigiosas",
      portfolioCategories: {
        all: "Todos",
        pop: "Exhibidores POP",
        vehicle: "Rotulación Vehicular",
        signage: "Señalización",
        largeformat: "Gran Formato",
        branding: "Branding"
      },
      quoteTag: "Comenzar",
      quoteTitle: "Solicitar Cotización",
      quoteDesc: "Cuéntanos sobre tu proyecto y te responderemos en 24 horas.",
      visitUs: "Visítanos",
      hours: "Lun-Vie: 9AM - 5PM",
      form: {
        name: "Nombre Completo *",
        email: "Correo Electrónico *",
        phone: "Teléfono",
        company: "Empresa",
        service: "Seleccionar Servicio",
        serviceOptions: {
          pop: "Exhibidores POP",
          vehicle: "Rotulación Vehicular",
          signage: "Señalización",
          branding: "Branding de Tienda",
          largeformat: "Impresión Gran Formato",
          other: "Otro"
        },
        message: "Cuéntanos sobre tu proyecto *",
        submit: "Enviar Solicitud",
        sending: "Enviando...",
        sent: "¡Enviado!",
        success: "¡Gracias! Nos pondremos en contacto pronto.",
        error: "Algo salió mal. Por favor intenta de nuevo."
      }
    },
    // Testimonials
    testimonials: {
      tag: "Historias de Éxito",
      title: "Lo Que Dicen Nuestros Clientes",
      subtitle: "33 años entregando excelencia a las marcas más prestigiosas de Puerto Rico"
    },
    // Rumbo Group Page
    rumbo: {
      heroTag: "La Primera Agencia Nativa de IA en Puerto Rico",
      heroTitle: "Marketing con IA para",
      heroTitleAccent: "Crecimiento Empresarial",
      heroDesc: "Marketing de nivel empresarial con IA para pequeñas y medianas empresas en Puerto Rico y más allá. Impulsado por IA. Entregado por expertos.",
      viewPricing: "Ver Precios",
      investorInfo: "Info para Inversores",
      bookConsultation: "Agendar Consulta",
      valueProps: {
        ai: "Impulsado por IA",
        bilingual: "Bilingüe EN/ES",
        tax: "4% Impuesto (Ley 60)",
        market: "PR + LATAM"
      },
      servicesTag: "Nuestros Servicios",
      servicesTitle: "8 Servicios Impulsados por IA",
      servicesDesc: "Todos los servicios aprovechan la IA para velocidad y calidad, entregando resultados de nivel empresarial a precios de PYME.",
      services: {
        web: { title: "Creación Web", desc: "Diseño y desarrollo de sitios web impulsados por IA" },
        social: { title: "Gestión de Redes Sociales", desc: "Gestión completa usando Digital Works AI" },
        app: { title: "Creación de Apps", desc: "Apps empresariales, portales de clientes, herramientas internas" },
        ads: { title: "Gestión de Anuncios", desc: "Meta Ads, Google Ads, TikTok Ads" },
        automation: { title: "Automatización IA", desc: "Chatbots, servicio al cliente, nutrición de leads" },
        brand: { title: "Identidad de Marca", desc: "Diseño de logo, guías de marca, sistemas visuales" },
        email: { title: "Email Marketing", desc: "Campañas y secuencias impulsadas por IA" },
        content: { title: "Estrategia de Contenido", desc: "Calendarios completos, copywriting, guiones de video" }
      },
      pricingTag: "Precios",
      pricingTitle: "Niveles de Retainer Mensual",
      pricingDesc: "Precios predecibles. Resultados poderosos. Escala mientras creces.",
      pricing: {
        basico: {
          name: "Básico",
          price: "$800-$1,500",
          period: "/mes",
          desc: "Para pequeñas empresas listas para establecer una presencia digital profesional",
          features: ["1-2 servicios principales", "Gestión de redes sociales", "Reportes básicos", "Soporte por email", "Llamada estratégica mensual"]
        },
        profesional: {
          name: "Profesional",
          price: "$2,500-$4,500",
          period: "/mes",
          desc: "Suite completa de marketing digital para empresas en crecimiento",
          features: ["3-5 servicios incluidos", "Creación de contenido", "Gestión de anuncios", "Automatización IA básica", "Llamadas quincenales", "Soporte prioritario"],
          popular: "MÁS POPULAR"
        },
        empresarial: {
          name: "Empresarial",
          price: "$7,500-$15,000+",
          period: "/mes",
          desc: "Asociación completa de agencia IA para empresas establecidas",
          features: ["Todos los servicios incluidos", "Gerente de cuenta dedicado", "Soluciones IA personalizadas", "Monitoreo diario", "Soporte 24/7 prioritario", "Revisiones estratégicas trimestrales"]
        }
      },
      getStarted: "Comenzar",
      synergyTag: "El Ecosistema",
      synergyTitle: "Graphic Works + Rumbo Group",
      synergyDesc: "Una relación de confianza. Soluciones empresariales completas. Desde señalización física y exhibidores retail hasta marketing digital impulsado por IA — tenemos tu marca cubierta desde todos los ángulos.",
      synergyGw: { title: "Graphic Works", desc: "Presencia física. 33 años de experiencia en exhibidores POP, señalización y rotulación vehicular para marcas de retail de lujo." },
      synergyRumbo: { title: "Rumbo Group", desc: "Presencia digital. Marketing impulsado por IA, desarrollo web y automatización para el panorama empresarial moderno." },
      contactTag: "Hablemos",
      contactTitle: "Inicia Tu Viaje con IA",
      contactDesc: "¿Listo para transformar tu presencia digital? Cuéntanos sobre tu negocio.",
      form: {
        interest: "¿Qué te interesa?",
        interestOptions: {
          basico: "Nivel Básico ($800-$1,500/mes)",
          profesional: "Nivel Profesional ($2,500-$4,500/mes)",
          empresarial: "Nivel Empresarial ($7,500+/mes)",
          project: "Proyecto Único",
          partnership: "Oportunidad de Asociación"
        },
        message: "Cuéntanos sobre tu negocio y objetivos *",
        submit: "Conectemos"
      }
    },
    // Resource Center
    resources: {
      heroTag: "Centro de Recursos de Marketing",
      heroTitle: "Todo lo que Necesitas para",
      heroTitleAccent: "Presentar y Vender",
      heroDesc: "Kit completo de marketing para presentaciones, pitches, emails y campañas publicitarias.",
      categories: {
        all: "Todos los Recursos",
        business: "Documentos de Negocio",
        onepagers: "One-Pagers",
        presentations: "Presentaciones",
        branding: "Activos de Marca",
        email: "Plantillas de Email",
        social: "Redes Sociales"
      },
      sections: {
        business: {
          title: "Documentos de Negocio",
          desc: "Planes de negocio oficiales, proyecciones financieras y materiales para inversores"
        },
        onepagers: {
          title: "One-Pagers (Teasers)",
          desc: "Documentos de resumen rápido perfectos para adjuntos de email e introducciones"
        },
        presentations: {
          title: "Presentaciones",
          desc: "Decks para inversores y presentaciones de ventas listas para personalizar"
        },
        branding: {
          title: "Activos de Marca",
          desc: "Logos, guías de marca y elementos de identidad visual"
        },
        email: {
          title: "Plantillas de Email",
          desc: "Plantillas de email listas para enviar para outreach y seguimientos"
        },
        social: {
          title: "Kit de Redes Sociales",
          desc: "Gráficos y contenido para marketing en redes sociales"
        }
      },
      download: "Descargar",
      preview: "Vista Previa",
      copyEmail: "Copiar al Portapapeles",
      copied: "¡Copiado!",
      useTemplate: "Usar Plantilla"
    },
    // Investor Portal
    investor: {
      heroTag: "Portal de Inversores y Socios",
      heroTitle: "Construyendo el Futuro del",
      heroTitleAccent: "Marketing IA en Puerto Rico",
      heroDesc: "Ventaja de primer movimiento en un mercado sin explotar. Estructura fiscal del 4%. Trayectoria de ingresos de $3M+.",
      metrics: {
        revenue: { value: "$3M+", label: "Meta de Ingresos Año 3" },
        tax: { value: "4%", label: "Impuesto Corporativo (Ley 60)" },
        clients: { value: "100+", label: "Base de Clientes Meta" },
        experience: { value: "33 Años", label: "Experiencia en la Industria" }
      },
      projections: {
        title: "Proyecciones de Ingresos",
        subtitle: "Trayectoria de Crecimiento Mensual Año 1",
        revenue: "Ingresos",
        netAfterTax: "Neto Después de Impuestos"
      },
      act60: {
        title: "Ventaja Fiscal Ley 60",
        desc: "La Ley 60 de Puerto Rico proporciona una ventaja financiera significativa para negocios de servicios de exportación. Rumbo Group califica para estos beneficios, permitiendo mayor reinversión y crecimiento más rápido.",
        corpTax: "Tasa de Impuesto Corporativo",
        divTax: "Impuesto de Dividendos PR",
        duration: "Duración del Decreto"
      },
      advantages: {
        title: "Foso Competitivo",
        subtitle: "Ventajas que se acumulan y no son fácilmente replicables",
        items: [
          { title: "Primera Agencia Nativa de IA en PR", desc: "Posición de primer movimiento para definir la categoría y establecer precios" },
          { title: "Plataforma Propietaria Digital Works AI", desc: "Plataforma construida y propia que proporciona ventajas estructurales de costos" },
          { title: "33 Años de Relaciones con Clientes", desc: "Acceso inmediato a empresas establecidas de PR vía Graphic Works" },
          { title: "Operaciones Bilingües EN/ES", desc: "Servicio auténtico para PR, mercado hispano de EE.UU. y LATAM" },
          { title: "Estructura Fiscal Ley 60", desc: "4% impuesto corporativo vs 21-37% tasas estándar de EE.UU." },
          { title: "Gastos Generales Ultra-Bajos", desc: "Operaciones aumentadas con IA con $1,800/mes de gastos" }
        ]
      },
      downloads: {
        title: "Centro de Descargas",
        subtitle: "Accede a nuestra documentación empresarial completa"
      },
      cta: {
        title: "¿Interesado en Asociarte?",
        desc: "Ya seas un inversor, socio potencial, o simplemente quieras aprender más, nos encantaría conectar y explorar oportunidades.",
        contactUs: "Contáctanos",
        call: "(787) 564-4035"
      }
    },
    // Admin Dashboard
    admin: {
      title: "Panel de Administración",
      login: {
        title: "Acceso Admin",
        password: "Contraseña",
        submit: "Entrar",
        error: "Contraseña inválida"
      },
      stats: {
        total: "Total de Consultas",
        new: "Nuevas",
        contacted: "Contactados",
        converted: "Convertidos",
        downloads: "Descargas"
      },
      filters: {
        all: "Todos",
        graphicWorks: "Graphic Works",
        rumboGroup: "Rumbo Group",
        statusAll: "Todos los Estados",
        new: "Nuevo",
        contacted: "Contactado",
        converted: "Convertido",
        archived: "Archivado"
      },
      table: {
        date: "Fecha",
        name: "Nombre",
        email: "Email",
        company: "Empresa",
        type: "Tipo",
        status: "Estado",
        actions: "Acciones"
      },
      detail: {
        phone: "Teléfono",
        service: "Servicio/Interés",
        message: "Mensaje",
        notes: "Notas",
        notesPlaceholder: "Agregar notas sobre este contacto...",
        updateStatus: "Actualizar Estado",
        saveNotes: "Guardar Notas",
        delete: "Eliminar",
        close: "Cerrar"
      },
      noContacts: "No se encontraron contactos"
    },
    // Booking Modal
    booking: {
      title: "Agendar una Consulta",
      desc: "Agenda una reunión con nuestro equipo o contáctanos directamente:",
      schedule: "Agendar en Calendly",
      respondTime: "Respondemos en 24 horas"
    },
    // Footer
    footer: {
      rumboDesc: "La primera agencia de marketing nativa de IA en Puerto Rico. Marcando el rumbo del crecimiento digital.",
      services: "Servicios",
      portfolio: "Portafolio",
      getQuote: "Cotizar",
      aiServices: "Servicios IA",
      pricing: "Precios",
      contact: "Contacto",
      rights: "Todos los derechos reservados."
    },
    // Common
    common: {
      phone: "Teléfono",
      email: "Email",
      location: "Ubicación",
      chatWithUs: "¡Escríbenos!"
    }
  }
};

export default translations;
